import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-neutral-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <h4 className="font-serif text-2xl text-white mb-3">RealOTK</h4>
          <p className="text-sm leading-relaxed text-neutral-400">
            Professional disciplinarian services in the Seattle area. Real spankings for real reasons.
          </p>
        </div>
        <div>
          <h5 className="text-white text-sm tracking-widest uppercase mb-4">Navigate</h5>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
            <li><Link to="/group-spanking" className="hover:text-white transition-colors">Group Spanking</Link></li>
            <li><Link to="/real-strapping" className="hover:text-white transition-colors">Real Strapping</Link></li>
            <li><Link to="/gallery" className="hover:text-white transition-colors">Gallery</Link></li>
            <li><Link to="/testimonials" className="hover:text-white transition-colors">Testimonials</Link></li>
            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/session-request" className="hover:text-white transition-colors">Session Request</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="text-white text-sm tracking-widest uppercase mb-4">Service Area</h5>
          <ul className="space-y-3 text-sm text-neutral-400">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 flex-shrink-0" /> Seattle, Tacoma, Everett and Bellevue</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 flex-shrink-0" /> realotk@mail.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <p>&copy; {new Date().getFullYear()} RealOTK. All rights reserved.</p>
          <p>Adults 18+ only. All sessions consensual.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
